import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { qk } from '@/lib/queryKeys';
import type { FeedingSchedule } from '@/lib/feedingSchedule';

export function useFeedingSchedule(farmId: string | null | undefined) {
  return useQuery({
    queryKey: qk.feedingSchedule.farm(farmId),
    queryFn: () => api.get<{ data: FeedingSchedule }>(`/api/v1/farms/${farmId}/feeding-schedule`).then((r) => r.data),
    enabled: !!farmId,
    staleTime: 5 * 60_000,
  });
}
